// extracted by mini-css-extract-plugin
module.exports = {"pillsContainer":"_3T9iB","filterName":"x-HyE","capitalizeText":"_39-x1","pillsContainerWhite":"geL28","filterNameWhite":"iLDd9"};